import { createAction, createSelector, createEntityAdapter, createSlice } from '@reduxjs/toolkit';

import _ from 'lodash';
import api from 'lib/api';
import utils from 'lib/utils';
import storage from 'lib/storage';
import notifications from 'lib/notifications';
import { kycApprovalService } from 'services';
import { fetchAdditionalInfoDeliveries } from 'services/deliveryAllotments/api';

const adapter = createEntityAdapter({
  // Assume IDs are stored in a field other than `id`
  // selectId: (deliveryScheduleDay) => _.get(deliveryScheduleDay, 'delivery_start_date_string', 0),
  // Keep the "all IDs" array sorted based on book titles
  // sortComparer: (a, b) => (a.name_of_farm || '').localeCompare(b.name_of_farm || ''),
});

const slice = createSlice({
  name: 'deliveriesCT',
  // initialState: booksAdapter.getInitialState(),
  initialState: adapter.getInitialState({
    busy: false,
    currentRequestId: null,
    csvReportData: [],
  }),
  // initialState: { ids: [], entities: {}, dirty: true },
  reducers: {
    setAll: adapter.setAll,
    addOne: adapter.addOne,
    addMany: adapter.addMany,
    updateOne: adapter.updateOne,
    updateMany: adapter.updateMany,
    upsertOne: adapter.upsertOne,
    upsertMany: adapter.upsertMany,
    removeOne: adapter.removeOne,
    removeMany: adapter.removeMany,
    removeAll: adapter.removeAll,
    setCsvReportData: (state, { payload }) => ({ ...state, csvReportData: payload }),
    setBusy(state, action) {
      let busy = action.payload;
      if (busy === false) {
        state.busy = false;
      } else {
        state.busy = true;
      }
    },
    setCurrentRequestId(state, action) {
      state.currentRequestId = action.payload;
    },
  },
});

const fetchList = (params) => async (dispatch, getState) => {
  const requestId = Date.now();
  dispatch(slice.actions.setCurrentRequestId(requestId));
  dispatch(slice.actions.setBusy(true));
  try {
    const resData = await kycApprovalService.fetchListCT(params);
    const ids = _.map(resData, 'transport_delivery_schedule_alloted_id') || [];
    let AdditionalParams = {
      ...params,
      transport_Delivery_Schedule_Allotted_Ids: ids,
      filters: {},
    };
    if (getState().deliveriesCT.currentRequestId !== requestId) return;
    if (!_.isEmpty(ids)) {
      let additionalInfoRes = await fetchAdditionalInfoDeliveries(AdditionalParams);
      let mergedArray = Object.values(resData).map((obj1) => {
        let obj2 = Object.values(additionalInfoRes).find(
          (obj2) => obj2.transport_delivery_schedule_alloted_id === obj1.transport_delivery_schedule_alloted_id,
        );
        return { ...obj1, ...obj2 };
      });
      dispatch(slice.actions.setAll(mergedArray));
    } else {
      dispatch(slice.actions.setAll(resData));
    }
  } catch (err) {
    if (getState().deliveriesCT.currentRequestId === requestId) {
      dispatch(slice.actions.setAll({}));
      utils.displayErrors(err);
    }
  }
  if (getState().deliveriesCT.currentRequestId === requestId) {
    dispatch(slice.actions.setBusy(false));
  }
};

const fetchDeliveriesByDealAndType = (params) => async (dispatch, getState) => {
  const requestId = Date.now();
  dispatch(slice.actions.setCurrentRequestId(requestId));
  dispatch(slice.actions.setBusy(true));
  try {
    const resData = await kycApprovalService.fetchDeliveriesByDealAndType(params);
    if (getState().deliveriesCT.currentRequestId !== requestId) return;
    dispatch(slice.actions.setAll(resData));
  } catch (err) {
    if (getState().deliveriesCT.currentRequestId === requestId) {
      dispatch(slice.actions.setAll({}));
      utils.displayErrors(err);
    }
  }
  if (getState().deliveriesCT.currentRequestId === requestId) {
    dispatch(slice.actions.setBusy(false));
  }
  dispatch(slice.actions.setBusy(false));
};

const fetchListReportData = (params) => {
  !params?.isCsv && dispatch(slice.actions.setBusy(true));
  return async (dispatch) => {
    try {
      const resData = await kycApprovalService.fetchListCT(params);
      if (params?.isCsv) {
        dispatch(slice.actions.setCsvReportData(Object.values(resData)));
      } else {
        dispatch(slice.actions.setAll(resData));
      }
      return resData;
    } catch (err) {
      dispatch(slice.actions.setAll({}));
      utils.displayErrors(err);
    } finally {
      dispatch(slice.actions.setBusy(false));
    }
  };
};

const revertDeliveries = (params) => async (dispatch) => {
  dispatch(slice.actions.setBusy(true));
  try {
    await kycApprovalService.revertDeliveries(params);
    dispatch(slice.actions.setBusy(false));
    return true;
  } catch (err) {
    dispatch(slice.actions.setAll({}));
    utils.displayErrors(err);
  }
  dispatch(slice.actions.setBusy(false));
};

const updateUnconfirmedDeliverySchedule = (params) => async (dispatch) => {
  dispatch(slice.actions.setBusy(true));
  try {
    await kycApprovalService.updateUnconfirmedDeliverySchedule(params);
    dispatch(slice.actions.setBusy(false));
    return true;
  } catch (err) {
    dispatch(slice.actions.setAll({}));
    utils.displayErrors(err);
  }
  dispatch(slice.actions.setBusy(false));
};

const linkDealsOrDeliveries = (params) => async (dispatch) => {
  try {
    const resData = await kycApprovalService.linkDealsOrDeliveries(params);
    return resData;
  } catch (err) {
    dispatch(slice.actions.setAll({}));
    utils.displayErrors(err);
  }
};

const deleteDealsOrDeliveriesFromLink = (params) => async (dispatch) => {
  try {
    const resData = await kycApprovalService.deleteDealsOrDeliveriesFromLink(params);
    return resData;
  } catch (err) {
    dispatch(slice.actions.setAll({}));
    utils.displayErrors(err);
  }
};

const RejectDelivery_CT = (params, id) => async (dispatch) => {
  try {
    return await kycApprovalService.RejectDelivery_CT(params, id);
  } catch (err) {
    dispatch(slice.actions.setAll({}));
    utils.displayErrors(err);
  }
};
const actions = {
  ...slice.actions,
  fetchList,
  fetchDeliveriesByDealAndType,
  fetchListReportData,
  revertDeliveries,
  RejectDelivery_CT,
  linkDealsOrDeliveries,
  deleteDealsOrDeliveriesFromLink,
  updateUnconfirmedDeliverySchedule,
};

// // Rename the exports for readability in component usage
// export const {
//   selectById: selectUserById,
//   selectIds: selectUserIds,
//   selectEntities: selectUserEntities,
//   selectAll: selectAllUsers,
//   selectTotal: selectTotalUsers
// } = usersAdapter.getSelectors(state => state.users)

const selectors = {
  ...adapter.getSelectors((state) => state.deliveriesCT),
};

export { actions, selectors };

export default slice.reducer;
